import { useMemo } from 'react';

import useAssetSnapshots from 'src/contexts/useAssetSnapshots';
import useLiabilitySnapshots from 'src/contexts/useLiabilitySnapshots';
import useBudgetSnapshots from 'src/contexts/useBudgetSnapshots';
import useAccountsSnapshots from 'src/contexts/useAccountSnapshots';
import useScenarioService from 'src/services/scenario-service';
import useGoalService from 'src/services/goal-service';
import useAccounts from 'src/contexts/useAccounts';
import useAssetService from 'src/services/asset-service';
import useLiabilityService from 'src/services/liability-service';
import { useBudgetPatches } from '../budget';
import { useTransactionRollups } from './useTransactionRollups';

export const usePlaidDataSource = (userId) => {
  // Provider data sources
  const { transactions, expenses, income, loading, fullRange } = useTransactionRollups(userId);
  const assetService = useAssetService(userId);
  const { liabilities: debts } = useLiabilityService(userId);
  const accounts = useAccounts(userId, debts);
  const scenarioService = useScenarioService(userId);
  const goalService = useGoalService(userId);

  // Snapshot Providers (historical)
  const patches = useBudgetPatches(userId);

  const assetSnapshots = useAssetSnapshots(userId);
  const budgetSnapshots = useBudgetSnapshots(userId);
  const accountsSnapshots = useAccountsSnapshots(userId);
  const liabilitySnapshots = useLiabilitySnapshots(userId);

  const result = {
    liabilitySnapshots,
    assetSnapshots,
    budgetSnapshots,
    accountsSnapshots,
    transactions,
    assetService,
    userAssets: assetService.assets,
    debts,
    income,
    expenses,
    loading,
    accounts, // the users connected plaid accounts
    patches, // budget patches
    fullRange, // the full date range of the data source
    goalService,
    scenarioService,
  };

  return useMemo(() => result, [result]);
};
